import React from "react";
import { Col, Row } from "react-bootstrap";
import logo from "../../white-logo.png";

const FooterComponent = () => {

    return (
        <footer >
            <Row className="text-center">
                <Col>
                    <img src={logo} alt="" className="img-fluid" width="40" />&nbsp;
                    ENERGO Managementportal &copy; <span className="text-energo">ENERGO Energiedienstleistungen GmbH</span>
                </Col>
            </Row>
        </footer>
    )
}

export default FooterComponent;